export enum DataSecurityApplicationStatus {
	Detected = 1,
	Added = 2,
	Deleted = 3,
	Blocked = 4,
}
